import React from 'react'
function Contest(props) {


    
    return (
        <div style={{backgroundColor:'red'}}>
       
            Contest 
        
        </div>
    )
}

export default Contest